/**
 * govedo-ui specific Slovenian translations.
 *
 * Empty by design — every string this app renders comes from
 * common/src/translations/slovenian.js (the `breedingValues.*` block).
 * Add keys here only for strings unique to the cattle module.
 */
export default {};
